import { Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";

const AlertsForm = ({ config, setConfig, setErrorAlerts, errorAlerts, version }) => {
  const { t } = useTranslation();

  const currentAlertTime = () => {
    if(config?.device_setting?.misc?.alert_warning_obj?.alert_off === 1) return 0;
    else if(config?.device_setting?.misc?.alert_warning_obj?.alert_5_min === 1) return 1;
    else if(config?.device_setting?.misc?.alert_warning_obj?.alert_10_min === 1) return 2;
    else if(config?.device_setting?.misc?.alert_warning_obj?.alert_20_min === 1) return 3;
  }

  const [alertFrequency, setAlertFrequency] = useState(currentAlertTime());

  const handleAlertChange = (value) => {
    //const value = e?.target?.value;
    switch(value) {
      case 0:
        handleAlertTimeChange("alert_off", "alert_5_min", "alert_10_min", "alert_20_min");
        break;
      case 1:
        handleAlertTimeChange("alert_5_min", "alert_off", "alert_10_min", "alert_20_min");
        break;
      case 2:
        handleAlertTimeChange("alert_10_min", "alert_5_min", "alert_off", "alert_20_min" );
        break;
      case 3:
        handleAlertTimeChange("alert_20_min", "alert_5_min", "alert_10_min", "alert_off");
        break;
    }

    setAlertFrequency(value);
  }
  

  const handleAlertWarningChange = (value, type) => {
    setConfig((prevConfig) => {
      if(type === "alert_warning") {
        return{
          ...prevConfig,
          device_setting: {
            ...prevConfig?.device_setting,
            misc: {
              ...prevConfig?.device_setting?.misc, alert_warning: value,},},};
      }
      else {
        return{
          ...prevConfig,
          device_setting: {
            ...prevConfig?.device_setting,
            misc: {
              ...prevConfig?.device_setting?.misc,
              alert_warning_obj: {
                ...prevConfig?.device_setting?.misc?.alert_warning_obj,
                [type]: value,
          }},},};}
    });
  };

  const handleAlertTimeChange = (time_active, time_no_1, time_no_2, time_no_3) => {
    setConfig((prevConfig) => ({
      ...prevConfig,
      device_setting: {
        ...prevConfig?.device_setting,
        misc: {
          ...prevConfig?.device_setting?.misc,
          alert_warning_obj: {
            ...prevConfig?.device_setting?.misc?.alert_warning_obj,
            [time_active]: 1,
            [time_no_1]: 0,
            [time_no_2]: 0,
            [time_no_3]: 0,
          },
        },
      },
    }));
  };
  
  return (<>
    { version>= 209 && (
    <Grid item xs={12}>
          <Typography
          color="secondary"
          style={{
              fontWeight: 500,
              fontSize: 22,
              lineHeight: "30px",
              marginTop: 18,}}>
          {t("common.alerts")}
          </Typography>
      </Grid>)}
    {( version>= 209 && version < 211) ? (
      
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
          label={t("devices.setUp.alert_warning")}
          value={config?.device_setting?.misc?.alert_warning}
          onChange={(e) => handleAlertWarningChange(e?.target?.value, "alert_warning") }
          kv
          values={[
            { key: 0, value: t("devices.setUp.alerts.off") },
            { key: 1, value: t("devices.setUp.alerts.on") },
          ]}
        />
      </Grid>
    ):(<>
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
          label={t("devices.setUp.alert_warning_obj.beep_auto_test")}
          value={config?.device_setting?.misc?.alert_warning_obj?.beep_auto_test}
          onChange={(e) => handleAlertWarningChange(e?.target?.value, "beep_auto_test") }
          kv
          values={[
            { key: 0, value: t("devices.setUp.alerts.off") },
            { key: 1, value: t("devices.setUp.alerts.on") },
          ]}
        />
      </Grid>
      { (version >= 212) && (
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
          label={t("devices.setUp.alert_warning_obj.rotaid")}
          value={config?.device_setting?.misc?.alert_warning_obj?.rotaid}
          onChange={(e) => {
              handleAlertWarningChange(e?.target?.value, "rotaid");
              handleAlertChange(0); }}
          kv
          values={[
            { key: 0, value: t("devices.setUp.alerts.off") },
            { key: 1, value: t("devices.setUp.alerts.on") },
          ]}
        />
      </Grid> )}

      {( version < 212 || config?.device_setting?.misc?.alert_warning_obj?.rotaid === 0) && (
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
          label={t("devices.setUp.alert_warning_obj.warning_time")}
          value={alertFrequency}
          onChange={(e) => handleAlertChange(e?.target?.value)}
          kv
          values={[
            { key: 0, value: t("devices.setUp.alerts.off") },
            { key: 1, value: t("devices.setUp.alert_warning_obj.alert_5_min") },
            { key: 2, value: t("devices.setUp.alert_warning_obj.alert_10_min") },
            { key: 3, value: t("devices.setUp.alert_warning_obj.alert_20_min") },
          ]}
        />
      </Grid> )}
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
          label={t("devices.setUp.alert_warning_obj.emit_msg")}
          value={config?.device_setting?.misc?.alert_warning_obj?.emit_msg}
          onChange={(e) => handleAlertWarningChange(e?.target?.value, "emit_msg") }
          kv
          values={[
            { key: 0, value: t("devices.setUp.alerts.off") },
            { key: 1, value: t("devices.setUp.alerts.on") },
          ]}
        />
      </Grid>
      </>
    )}
  </>);
};

export default AlertsForm;
